module.exports = __webpack_public_path__ + "static/media/manage_product_ inventory.72e1dda4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/manage_product_ inventory.svg
// module id = 176
// module chunks = 0